import React from "react";

import styles from "./Overlay.css";

const Overlay = (props) => {
  return (
    <div onClick={props.onClick} className={styles.overlay}></div>
  );
};

export default Overlay;



// WEBPACK FOOTER //
// ./src/components/Library/Overlay/Overlay.js